import {useEffect, useState} from "react";
import "./UpdateChecker.scss"
import updateImage from "./update.svg"
import {RaikoBaseCardContainer,RaikoButtonPrimary,RaikoButtonSecondary} from "@moeindal/base-raiko-panel-components";

export default function UpdateChecker({children}) {

    const VERSION_CODE = "VERSION_CODE"

    useEffect(() => {
        const versionCode = process.env.REACT_APP_VERSION_CODE
        const lastVersionCode = window.sessionStorage.getItem(VERSION_CODE)

        console.log("version code is ", versionCode)
        console.log("last version code is ", lastVersionCode)

        if (
            typeof lastVersionCode !== 'undefined' && typeof versionCode !== 'undefined' && lastVersionCode !== null &&
            (parseInt(lastVersionCode) !== parseInt(versionCode))
        ) {
            console.log("result of condition is true")
            setUpdateNotificationState(true)
        } else if (lastVersionCode === null) {
            console.log("result of condition is false")
            window.sessionStorage.setItem(VERSION_CODE, versionCode)
        }

    }, []);


    const [updateNotificationState, setUpdateNotificationState] = useState(false)

    function handleUpdate() {
        // location.reload(true)
        window.sessionStorage.setItem(VERSION_CODE, process.env.REACT_APP_VERSION_CODE)
        window.location.reload(true)
    }

    function handleCloseDialog() {
        setUpdateNotificationState(false)
    }

    return (
        <>
            {
                updateNotificationState ?
                    <div className={"baseUpdateCheckerContainer"}>
                        <RaikoBaseCardContainer className={"updateCheckerInfoContainer"}>

                            <img src={updateImage} alt="update"/>
                            <span className={"title"}>بروزرسانی جدید رسید !!!</span>
                            <span className={"subtitle"}>لطفا برای دستیابی به جدید ترین ویژگی ها پنل خود را به آخرین نسخه بروزرسانی نمایید.</span>
                            <div className={"actionButtonContainer"}>
                                <RaikoButtonPrimary label={"بروزرسانی"} onClick={handleUpdate}/>
                                <RaikoButtonSecondary label={"انصراف"} onClick={handleCloseDialog}/>
                            </div>

                        </RaikoBaseCardContainer>
                    </div> :
                    ""
            }
            {children}
        </>
    )
}
